<template>
    <body class="white-bg">
        <div class="research">
            <div class="ibox page-full">
                <div class="r-header">본인 인증</div>
                <div id="smsAuth" class="ibox-content">
                    <div class="text-center mt-4">
                        <div class="form-group" style="margin-top: 20px; padding-left: 50px; padding-right: 50px;">
                            <div class="input-group">
                                <input type="text" v-model="employeeNumber" placeholder="사원번호 입력" class="form-control" style="border-color: rgb(51, 122, 183); text-align: center; border-radius: 0px; font-size: 20px;">
                            </div>
                            <div class="input-group">
                                <input type="text" v-model="phone" placeholder="전화번호 입력 ('-' 없이 숫자만)" class="form-control" style="border-color: rgb(51, 122, 183); text-align: center; border-radius: 0px; font-size: 20px;">
                            </div>
                        </div>
                        <button id="sendAuthBtn" class="r-font-size btn btn-w-m btn-success r-btn-blue" @click="requestCode">SMS 인증요청</button>

                        <div style="margin-top: 10px; color: rgb(255, 34, 34); font-size: 17px;"></div>

                        <div style="text-align: left; padding: 20px; font-size: 18px;">
                            <div align="center">
                                문자로 받은 <b>인증번호 6자리</b>
                                를 <b>5분 이내</b> 입력해주세요.
                            </div>
                        </div>
                        
                        <div class="form-group" style="margin-top: 20px; padding-left: 50px; padding-right: 50px;">
                            <div class="input-group">
                                <input type="text" v-model="code" :disabled="!codeSent" placeholder="인증번호 입력" class="form-control" style="border-color: rgb(51, 122, 183); text-align: center; border-radius: 0px; font-size: 20px;">
                                <!-- <span class="input-group-addon" style="color: rgb(255, 34, 34); font-size: 18px; text-align: center;">03:00</span> -->
                            </div>
                        </div>
                        <div class="mt-2 mb-4" style="color: rgb(255, 34, 34); font-size: 17px;"></div>
                        <button class="r-font-size btn btn-primary r-btn-blue" @click="next">확인</button>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
import Auth from '@/services/Auth'
import AuthService from '@/services/AuthService'

export default {
  name: 'auth',
  props: {
    //msg: String
  },
  data() {
    return {
        hash: null,
        employeeNumber: null,
        phone: null,
        code: null,
        codeSent: false,

        codeToken: null,
    }
  },
  mounted() {
    this.hash = this.$route.params.hash
    window.scrollTo(0, 0)
    
  },
  methods: {
      requestCode() {
          if (!this.employeeNumber) {
              alert("사번을 입력해주세요")
              return
          }

          if (!this.phone) {
              alert("전화번호를 입력해주세요")
              return
          }

          AuthService.requestCode(this.phone, this.hash,
            (data_ok) => {
                if (!data_ok.success) {
                    alert(data_ok.message)
                    return
                }
                this.codeSent = true
                alert("인증번호가 발송되었습니다.")
            }
          )
      },

      next() {
          if (!this.employeeNumber) {
              alert("사번을 입력해주세요")
              return
          }

          if (!this.phone) {
              alert("전화번호를 입력해주세요")
              return
          }

          if (!this.code) {
              alert("인증번호를 입력해주세요")
              return
          }

        //   let that = this

          AuthService.confirmCode(
            this.phone, this.code, this.hash,
            (data_ok) => {
                if (!data_ok.success) {
                    alert(data_ok.message)
                    return
                }

                // Save token and elector info
                Auth.setToken(data_ok.data.token)
                
                // Check if user already has nominee registration
                // For now, go directly to register page
                this.$router.push({name: 'nominee-register', params: {hash: this.hash}})
            }
          )
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
